import React, { useState } from "react";
import Reveal from "../Components/Reveal";

const shell = "px-4 py-5 shadow-panel md:px-5 md:py-6";
const supportEmail = "tba@trustbroker.africa";

const pgpKeys = [
  {
    id: "ticket-system",
    title: "Ticket System Key",
    userId: "TrustBroker Africa (TBA) ** TICKET SYSTEM **",
    email: supportEmail,
    keyId: "966D5533",
    fingerprint: "5A70 453F 2E00 FF3C 36B7 7CBB 014F 2864 966D 5533",
    fingerprintPreview: "5A70...5533",
    type: "RSA (4096)",
  },
  {
    id: "master-signing",
    title: "Master Signing Key",
    userId: "TrustBroker Africa (TBA) ** MASTER SIGNING **",
    keyId: "C1AEC76D",
    fingerprint: "5474 A6FE B846 5ACB EC5C 3A75 9510 5F46 C1AE C76D",
    fingerprintPreview: "5474...C76D",
    type: "RSA (4096)",
  },
];

const governanceResponsibilities = [
  "Oversight of team listing and accreditation processes",
  "Coordination of community collaboration activities",
  "Review of service performance and development",
];

function Support() {
  const [copiedItem, setCopiedItem] = useState("");
  const [openPgpKey, setOpenPgpKey] = useState("ticket-system");

  const copyText = async (text, item) => {
    if (!navigator.clipboard?.writeText) {
      return;
    }

    await navigator.clipboard.writeText(text);
    setCopiedItem(item);
    window.setTimeout(() => setCopiedItem(""), 1600);
  };

  return (
    <div className="space-y-6 text-ink-900">
      <Reveal as="section" className={shell}>
        <div className="space-y-5">
          <div className="max-w-9xl space-y-4 text-left">
            {/* <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-500">
              Contact
            </p> */}
            <h1 className="m-0 text-left text-4xl font-semibold tracking-tight text-sky-700 md:text-5xl">
              Contact TrustBroker Africa
            </h1>
            <p className="m-0 text-lg leading-8 text-slate-700">
              TrustBroker Africa supports cybersecurity collaboration across
              Africa. For enquiries, partnerships, or participation, contact the
              team below.
            </p>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <Reveal
              className="rounded-lg border border-slate-200 bg-white p-4 text-left shadow-sm"
              delay={100}
            >
              <div className="flex items-start gap-4">
                <span aria-hidden="true" className="mt-1 flex-none">
                  &#128205;
                </span>
                <div>
                  <h3 className="m-0 font-semibold text-ink-900">
                    Service Address
                  </h3>
                  <div className="mt-2 space-y-1 text-base leading-7 text-slate-700">
                    <p className="m-0">c/o WACREN</p>
                    <p className="m-0">VCG Office Complex, IPS Road</p>
                    <p className="m-0">P.O. Box LG 1279</p>
                    <p className="m-0">Accra, Ghana</p>
                  </div>
                </div>
              </div>
            </Reveal>

            <Reveal
              className="rounded-lg border border-slate-200 bg-white p-4 text-left shadow-sm"
              delay={160}
            >
              <div className="flex items-start gap-4">
                <span aria-hidden="true" className="mt-1 flex-none">
                  &#9993;
                </span>
                <div>
                  <h3 className="m-0 font-semibold text-ink-900">Email</h3>
                  <p className="mb-0 mt-2 flex flex-wrap items-center gap-3 text-base leading-7 text-slate-700">
                    <a
                      href={`mailto:${supportEmail}`}
                      className="font-semibold text-sky-700 no-underline transition hover:text-sky-800 hover:underline"
                    >
                      {supportEmail}
                    </a>
                    <button
                      type="button"
                      onClick={() => copyText(supportEmail, "contact-email")}
                      className="rounded border border-slate-300 bg-slate-50 px-3 py-1 font-semibold text-slate-700 transition hover:bg-slate-100"
                    >
                      {copiedItem === "contact-email" ? "Copied" : "Copy"}
                    </button>
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </Reveal>

      <Reveal as="section" className={shell} delay={120}>
        <div className="max-w-9xl space-y-5">
          <div className="space-y-4 text-left">
            {/* <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-500">
              Secure Communication
            </p> */}
            <h2 className="m-0 text-3xl font-semibold tracking-tight text-sky-700 md:text-4xl">
              Secure Communication
            </h2>
            <p className="m-0 text-lg leading-8 text-slate-700">
              Send sensitive information using encrypted email with OpenPGP.
              Expand a key below to view details.
            </p>
          </div>

          <div className="space-y-3 text-left">
            {pgpKeys.map((key) => {
              const isOpen = openPgpKey === key.id;

              return (
                <Reveal
                  key={key.id}
                  className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm"
                  delay={160}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() =>
                      setOpenPgpKey((current) =>
                        current === key.id ? "" : key.id
                      )
                    }
                    className="flex w-full items-center justify-between gap-4 bg-white px-4 py-3 text-left font-semibold text-ink-900 transition hover:bg-slate-50"
                  >
                    <span>{key.title}</span>
                    <span aria-hidden="true" className="text-xl font-semibold">
                      {isOpen ? "-" : "+"}
                    </span>
                  </button>

                  {isOpen ? (
                    <div className="border-t border-slate-200 px-4 py-3">
                      <div className="space-y-2">
                        {key.email ? (
                          <div className="grid gap-2 md:grid-cols-[9rem_1fr_auto] md:items-center">
                            <span className="text-slate-600">Email:</span>
                            <a
                              href={`mailto:${key.email}`}
                              className="font-semibold text-sky-700 no-underline transition hover:text-sky-800 hover:underline md:text-right"
                            >
                              {key.email}
                            </a>
                            <button
                              type="button"
                              onClick={() =>
                                copyText(key.email, `${key.id}-email`)
                              }
                              className="w-fit rounded border border-slate-300 bg-slate-50 px-3 py-1 font-semibold text-slate-700 transition hover:bg-slate-100"
                            >
                              {copiedItem === `${key.id}-email`
                                ? "Copied"
                                : "Copy"}
                            </button>
                          </div>
                        ) : null}

                        <div className="grid gap-2 md:grid-cols-[9rem_1fr_auto] md:items-center">
                          <span className="text-slate-600">Key ID:</span>
                          <span className="font-semibold text-ink-900 md:text-right">
                            {key.keyId}
                          </span>
                          <button
                            type="button"
                            onClick={() => copyText(key.keyId, `${key.id}-id`)}
                            className="w-fit rounded border border-slate-300 bg-slate-50 px-3 py-1 font-semibold text-slate-700 transition hover:bg-slate-100"
                          >
                            {copiedItem === `${key.id}-id` ? "Copied" : "Copy"}
                          </button>
                        </div>

                        <div className="grid gap-2 md:grid-cols-[9rem_1fr_auto] md:items-center">
                          <span className="text-slate-600">Fingerprint:</span>
                          <span
                            className="font-semibold text-ink-900 md:text-right"
                            title={key.fingerprint}
                          >
                            {key.fingerprintPreview}
                          </span>
                          <button
                            type="button"
                            onClick={() =>
                              copyText(key.fingerprint, `${key.id}-fingerprint`)
                            }
                            className="w-fit rounded border border-slate-300 bg-slate-50 px-3 py-1 font-semibold text-slate-700 transition hover:bg-slate-100"
                          >
                            {copiedItem === `${key.id}-fingerprint`
                              ? "Copied"
                              : "Copy"}
                          </button>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() => setOpenPgpKey("")}
                        className="mt-3 p-0 font-semibold text-sky-700 transition hover:text-sky-800 hover:underline"
                      >
                        Hide details
                      </button>
                      <div className="mt-2 space-y-1 text-slate-700">
                        <p className="m-0">User ID: {key.userId}</p>
                        <p className="m-0">Type: {key.type}</p>
                      </div>
                    </div>
                  ) : null}
                </Reveal>
              );
            })}
          </div>
        </div>
      </Reveal>

      <Reveal as="section" className={shell} delay={200}>
        <div className="grid max-w-9xl grid-cols-1 gap-5">
          <div className="space-y-6">
            {/* <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-500">
              Governance
            </p> */}
            <h2 className="m-0 text-3xl font-semibold tracking-tight text-sky-700 md:text-4xl">
              Service Governance
            </h2>
            <p className="m-0 text-lg leading-8 text-slate-700">
              TrustBroker Africa is operated by WACREN as part of the WACREN
              Cybersecurity &amp; Trust Programme.
            </p>
            <p className="m-0 text-lg leading-8 text-slate-700">
              The initiative builds on collaboration across the African
              research and education networking community and works with
              partners across the broader cybersecurity ecosystem to strengthen
              trusted cybersecurity collaboration across Africa.
            </p>
            <p className="m-0 text-lg leading-8 text-slate-700">
              The TrustBroker Africa Steering Committee provides oversight of
              the service and supports the development of the community.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4">
            <div className="rounded-lg border border-slate-200 bg-slate-50/80 p-4 text-left shadow-sm">
              <p className="m-0 text-base font-semibold text-ink-900">
                Responsibilities include:
              </p>
              <ul className="mb-0 mt-3 divide-y divide-slate-200 p-0 text-base leading-7 text-slate-700">
                {governanceResponsibilities.map((responsibility) => (
                  <li key={responsibility} className="flex items-start gap-3 py-3">
                    <span className="mt-2 h-2 w-2 flex-none rounded-full bg-sky-700" />
                    <span>{responsibility}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-slate-200 bg-slate-50/80 p-4 text-left shadow-sm">
              <h3 className="m-0 text-2xl font-semibold text-ink-900">
                Service Manager
              </h3>
              <p className="mb-0 mt-4 text-base leading-7 text-slate-700">
                The TrustBroker Africa service manager is Omo Oaiya.
              </p>
              <p className="mb-0 mt-3 text-base leading-7 text-slate-700">
                For service matters or escalations, please contact him directly.
                If required, encrypted communication may be used via{" "}
                <a
                  href="/Omo keys.odt"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-sky-700 no-underline transition hover:text-sky-800 hover:underline"
                >
                  his PGP key
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
}

export default Support;
